module.exports = __webpack_public_path__ + "static/nomster-cd7e1dad5db048a4b9c95637fe20ea21.png";